import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const hoikuKyoikuHoushinChigai: BlogMetaData = {
  title: '保育園の教育とは？方針の違いを比べる5つの軸と見学で確かめるポイント',
  description:
    '保育園の教育とは何か、園ごとの教育方針の違いをどう比べるかを解説。子ども主導か大人主導か、個別か集団かなど5つの軸と、モンテッソーリ・英語・運動・遊び中心の考え方、見学で実際の保育を確かめる質問をまとめました。',
  thumbnailUrl: '/img/blog-hoiku-kyoiku-houshin-chigai.webp',
  filePath: buildBlogFilePath('hoiku-kyoiku-houshin-chigai'),
  category: BLOG_CATEGORY.NURSERY,
};
